// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--VufP8";
export var borderRadius = "index-module--border-radius--N6-Uj";
export var clearButtonStyles = "index-module--clear-button-styles--pzjRo";
export var map_container = "index-module--map_container--oujYI";
export var titleFont = "index-module--title-font--JdcoV";